import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from "@angular/material/button";
import { provideTranslationScope, TranslationPipeModule } from "@ogs-gmbh/ngx-translate";

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  providers: [ provideTranslationScope("shared/confirmation-dialog") ],
  imports: [
    MatDialogModule,
    MatButtonModule,
    TranslationPipeModule
  ],
  templateUrl: './confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationDialogComponent {
  title: InputSignal<string> = input.required<string>();

  message: InputSignal<string> = input.required<string>();

  confirmText: InputSignal<string> = input('');

  cancelText: InputSignal<string> = input('');

  @Output() readonly confirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() readonly cancelClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor (
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {}

  onConfirm (): void {
    this.dialogRef.close(true);
  }

  onCancel (): void {
    this.dialogRef.close(false);
  }
}
